import { Component, inject, Input, OnInit } from '@angular/core';
import { TournamentCategory } from '../shared/tournament-category';
import { PlayerGroupExtended } from '../category-group-component/category-group-component';
import { Observable } from 'rxjs';
import { OpenSquashService } from '../shared/services/open-squash-service';
import { Player } from '../shared/model/player';
import { CommonModule } from '@angular/common';
import { Tournament } from '../shared/tournament';

@Component({
  selector: 'app-category-classification-group',
  imports: [CommonModule],
  templateUrl: './category-classification-group.html',
  styleUrl: './category-classification-group.scss'
})
export class CategoryClassificationGroup implements OnInit {
  @Input() category!: TournamentCategory | undefined;
  private players: Player[] = [];
  playersGroup: PlayerGroupExtended[] = [];

  private openSquashService = inject(OpenSquashService);
  esAdmin$!: Observable<boolean>;

  constructor() {
    this.esAdmin$ = this.openSquashService.esAdmin$;
    this.openSquashService.getPlayers().subscribe(players => this.players = players);

    // this.route.paramMap.subscribe(params => {
    //   this.categoryType = params.get('categoryType');
    // });
  }

  ngOnInit() {
    this.loadPlayers();
  }

  private loadPlayers() {
    // Simulate loading players for the category
    this.playersGroup = this.category?.players || [];
    this.playersGroup.map(playerGroup => {
      const player = this.players.find(p => p.playerId === playerGroup.playerId);
      if (player) {
        playerGroup.player = player;
      }
    });
    this.playersGroup.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  resolveClassification() {
    // Crear un array con todos los PlayerGroup que existan en category.groups.players
    const allPlayers: PlayerGroupExtended[] = [];
    this.category?.groups?.forEach(group => {
      if (group.players) {
        group.players.forEach(playerGroup => {
          allPlayers.push({
            ...playerGroup,
            matchesPlayed: 0,
            matchesWon: 0,
            matchesLost: 0,
            setsWon: 0,
            setsLost: 0,
            pointsWon: 0,
            pointsLost: 0,
            finalMatches: 0
          });
        });
      }
    });


    // Recorrer quarterfinals y semifinals buscando byes
    const finals = this.category?.finals;
    (['quarterfinals', 'semifinals'] as const).forEach((round) => {
      const matches = finals?.[round];
      if (Array.isArray(matches)) {
        matches.forEach(match => {
          if (match.player1Bye) {
            const playerGroup = allPlayers.find(pg => pg.playerId === match.player2Id);
            if (playerGroup) {
              playerGroup.finalMatches = (playerGroup.finalMatches ?? 0) + 1;
            }
          }
          if (match.player2Bye) {
            const playerGroup = allPlayers.find(pg => pg.playerId === match.player1Id);
            if (playerGroup) {
              playerGroup.finalMatches = (playerGroup.finalMatches ?? 0) + 1;
            }
          }
        });
      }
    });
    
    // this.category?.finals?.quarterfinals?.forEach(final => {

    this.openSquashService.matches$.subscribe(matches => {
      // Recorrer todos los jugadores y calcular sus estadísticas
      allPlayers.forEach(playerGroup => {
        const playerMatches = matches.filter(m => m.player1Id === playerGroup.playerId || m.player2Id === playerGroup.playerId);
        playerGroup.matchesPlayed = playerMatches.length;
        playerMatches.forEach(match => {
          if (match.groupName === 'finales') {
            playerGroup.finalMatches = (playerGroup.finalMatches ?? 0) + 1;
          }
          playerGroup.matchesWon = (playerGroup.matchesWon ?? 0) + (match.playerIdWinner === playerGroup.playerId ? 1 : 0);
          playerGroup.matchesLost = (playerGroup.matchesLost ?? 0) + (match.playerIdWinner !== playerGroup.playerId ? 1 : 0);
          const setsWon = match.player1Id === playerGroup.playerId ? match.player1GamesWon : match.player2GamesWon;
          const setsLost = match.player1Id === playerGroup.playerId ? match.player1GamesLost : match.player2GamesLost;
          playerGroup.setsWon = (playerGroup.setsWon ?? 0) + (setsWon ?? 0);
          playerGroup.setsLost = (playerGroup.setsLost ?? 0) + (setsLost ?? 0);
          const pointsWon = match.player1Id === playerGroup.playerId ? match.player1PointsWon : match.player2PointsWon;
          const pointsLost = match.player1Id === playerGroup.playerId ? match.player1PointsLost : match.player2PointsLost;
          playerGroup.pointsWon = (playerGroup.pointsWon ?? 0) + (pointsWon ?? 0);
          playerGroup.pointsLost = (playerGroup.pointsLost ?? 0) + (pointsLost ?? 0);
        });
      });

      const sortedPlayers = [...allPlayers].sort((a, b) => {
        // 1. Ordenar por playerGroup.finalMatches descendente
        const playerMatchesDiff = (b.finalMatches || 0) - (a.finalMatches || 0);
        if (playerMatchesDiff !== 0) return playerMatchesDiff;

        // 2. Ordenar por matchesWon descendente
        const matchesDiff = (b.matchesWon || 0) - (a.matchesWon || 0);
        if (matchesDiff !== 0) return matchesDiff;

        // 3. Si empate, ordenar por diferencia setsWon - setsLost descendente
        const setsDiffA = (a.setsWon || 0) - (a.setsLost || 0);
        const setsDiffB = (b.setsWon || 0) - (b.setsLost || 0);
        const setsDiff = setsDiffB - setsDiffA;
        if (setsDiff !== 0) return setsDiff;

        // 4. Si empate, ordenar por diferencia pointsWon - pointsLost descendente
        const pointsDiffA = (a.pointsWon || 0) - (a.pointsLost || 0);
        const pointsDiffB = (b.pointsWon || 0) - (b.pointsLost || 0);
        return pointsDiffB - pointsDiffA;
      });

      // Asignar el orden comenzando en 1
      sortedPlayers.forEach((player, idx) => {
        player.order = idx + 1;
      });

      // Remover el atributo player de cada objeto en sortedPlayers
      sortedPlayers.forEach(player => {
        delete player.player;
      });
      console.log('sortedPlayers', sortedPlayers);
      this.category!.players = sortedPlayers;

      this.category!.groups = (this.category?.groups ?? []).filter(g => g.name !== 'finales' && g.name !== 'posiciones');

      this.openSquashService.updatePositions(this.category!).subscribe();

      // this.playersGroup = sortedPlayers.map(player => ({ ...player }));
      // this.playersGroup.map(playerGroup => {
      //   const player = this.players.find(p => p.playerId === playerGroup.playerId);
      //   if (player) {
      //     playerGroup.player = player;
      //   }
      // });
      // this.playersGroup.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    });



  }

}
